import axios from "axios";
import BaseService from "./baseService";

class ServiceNoReplyEmailController extends BaseService {
  async startRefresh() {
    const response = await axios.post("/api/noReplyEmail/startRefresh");
    return response.data;
  }
  async stopRefresh() {
    const response = await axios.post("/api/noReplyEmail/stopRefresh");
    return response.data;
  }
  async processUnreadEmails() {
    const response = await axios.post("/api/noReplyEmail/processUnreadEmails");
    return response.data;
  }
  async getStatus() {
    const response = await axios.get("/api/noReplyEmail/status");
    return response.data;
  }
}

export const ServiceNoReplyEmail = new ServiceNoReplyEmailController();